module.exports = __webpack_public_path__ + "img/jiaoshou.3d6a0efa.png";